/**
 * Helper functions for todo upload tracking
 */

/**
 * Check if a todo has pending uploads
 * @param {string} todoId - The todo ID to check
 * @param {Object} todoUploads - The todo uploads state from Redux
 * @returns {boolean} - True if the todo has pending uploads
 */
export const hasPendingUploads = (todoId, todoUploads) => {
  const uploadStatus = todoUploads[todoId]
  return uploadStatus && uploadStatus.pendingCount > 0
}

/**
 * Get upload progress information for a todo
 * @param {string} todoId - The todo ID to get progress for
 * @param {Object} todoUploads - The todo uploads state from Redux
 * @returns {Object|null} - Progress object with pending, total, finished, hasErrors properties, or null if no upload status
 */
export const getUploadProgress = (todoId, todoUploads) => {
  const uploadStatus = todoUploads[todoId]
  if (!uploadStatus) return null
  return {
    pending: uploadStatus.pendingCount,
    total: uploadStatus.totalCount,
    finished: uploadStatus.finishedCount,
    hasErrors: uploadStatus.hasErrors,
  }
}
